import { formatRupeeLabel } from '../../../../../display-values/lumpsumPlanAmount'
import type { LumpsumRebalanceNoActionFund } from '../../../../api/rebalance.types'
import { PlanCategoryBucketKey } from '../../../../api/types'
import { useOpenPlanRecommendationBottomSheet } from '../../../../plan-bottom-sheet/open/useOpenPlanRecommendationBottomSheet'
import { AllocationFundCardTrailingLayout } from '../../../lumpsum-ui-components/AllocationFundCardTrailingLayout'
import { PlansFundCard, type PlanFundCardCta } from '../../../lumpsum-ui-components/PlansFundCard'
import { ALLOCATION_NO_ACTION_FUND_CARD_NO_CHANGE_ICON_SVG } from '../../allocation/cards/AllocationNoActionFundCard'
import { PlansFundRole, PlansScreen } from '../../../../../analytics/plansEvents'
import { trackPlansFundCardCta, trackPlansFundCardOpen } from '../../../../../analytics/plansTrack'

type RebalanceNoActionFundCardProps = {
  fund: LumpsumRebalanceNoActionFund
  showBottomDivider?: boolean
}

export function RebalanceNoActionFundCard({
  fund,
  showBottomDivider = true
}: RebalanceNoActionFundCardProps) {
  const { openIdealPlanRecommendationBottomSheet } = useOpenPlanRecommendationBottomSheet()
  const isin = fund?.isin ?? ''
  const fundName = fund?.fundName ?? ''
  const screenName = PlansScreen.LumpsumRebalance
  const fundRole = PlansFundRole.NoAction

  const openPlanBottomSheet = () => {
    openIdealPlanRecommendationBottomSheet({
      isin,
      bucketType: PlanCategoryBucketKey.noActionFunds
    })
  }

  const handleCardClick = () => {
    trackPlansFundCardOpen({ screenName, fundRole, fundName, fundIsin: isin })
    openPlanBottomSheet()
  }

  const ctas: PlanFundCardCta[] = [
    {
      id: `${isin}-no-change`,
      label: 'No change',
      onClick: () => {
        trackPlansFundCardCta({ screenName, fundRole, buttonLabel: 'No change', fundName, fundIsin: isin })
        console.log('No change', isin)
      },
      variant: 'completed'
    },
    {
      id: `${isin}-learn-more`,
      label: 'Learn more',
      onClick: () => {
        trackPlansFundCardCta({ screenName, fundRole, buttonLabel: 'Learn more', fundName, fundIsin: isin })
        openPlanBottomSheet()
      },
      variant: 'tertiary'
    }
  ]

  return (
    <PlansFundCard
      fund={{
        isin,
        logoUrl: fund?.mfLogoUrl ?? '',
        title: fundName,
        fundNature: fund?.fundNature ?? '',
        category: fund?.fundCategory ?? '',
        purchaseMode: fund?.purchaseMode ?? ''
      }}
      topRight={<RebalanceNoActionFundCardTrailing currentValue={fund?.currentValue ?? 0} />}
      status={{
        rank: fund?.powerRank ?? 0,
        rating: fund?.powerRating ?? ''
      }}
      ctas={ctas}
      showBottomDivider={showBottomDivider}
      onCardClick={handleCardClick}
    />
  )
}

export function RebalanceNoActionFundCardTrailing({ currentValue }: { currentValue: number }) {
  return (
    <AllocationFundCardTrailingLayout
      primaryLabel={`${formatRupeeLabel({ rawAmount: currentValue })}`}
      secondaryIconHtml={ALLOCATION_NO_ACTION_FUND_CARD_NO_CHANGE_ICON_SVG}
      secondaryText='No change'
    />
  )
}
